import React from 'react';
import {AvForm} from 'availity-reactstrap-validation';
import Loading from "../../shared/component/others/Loading";
import DataTable from "../../shared/component/dataTable/DataTable";
import ZXReportService from "../../shared/service/ZXReportService";
import SaleReportColumn from "../../shared/component/dataTable/columns/SaleReportColumn.json";
import SaleReportArchieveMobileColumn
    from "../../shared/component/dataTable/columns/SaleReportArchieveMobileColumn.json";

import ModalConfirm from "../../shared/component/dialog/ModalConfirm";
import {Button} from "reactstrap";
import Translate from "../../shared/language/Translate";
import {TabPanel, TabView} from 'primereact/tabview';
import SaleReportArchieveColumn from "../../shared/component/dataTable/columns/SaleReportArchieveColumn.json";
import Dialog from "../../shared/component/dialog/Dialog";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import SaleReportDetail from "./SaleReportDetail";
import MerchantBranchCredentialsService from "../../shared/service/MerchantBranchCredentialsService";
import {Chart} from "primereact/chart";
import DateInput from "../../shared/component/form/DateInput";
import AvField from "../../shared/component/form/AvField";
import SaleReportMergeDetail from "./SaleReportMergeDetail";
import {DAYS_FILTER} from "../../shared/utils/Constants";
import './SaleReportPage.css';
import '../../shared/styles/SettingsPage.css';

const defaultSummary = {
    netSale: 0,
    grossSale: 0,
    refunds: 0,
    netSaleCnt: 0,
    grossSaleCnt: 0,
    refundsCnt: 0,
    totalSale: 0,
    tillTotalSale: 0,
    tillCash: 0,
    tillCard: 0,
    webPay: 0,
};

export default class SaleReport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            saleReportList: [],
            clientList: [],
            daysFilter: "Last 7 Days",
            startDate: GeneralUtils.getLast7DaysRange()[0].getTime(),
            endDate: GeneralUtils.getLast7DaysRange()[1].getTime(),
            reportStartNo: null,
            reprotEndNo: null,
            loading: false,
            summary: Object.assign(defaultSummary),
        };
        this.zxReportService = new ZXReportService();
        this.merchantBranchCredentialsService = new MerchantBranchCredentialsService();

    }

    componentDidMount() {
        this.merchantBranchCredentialsService.getClientTills(localStorage.getItem('merchantBranchId')).then(response => this.setState({
            clientList: response
        }));
        this.refreshSummary();

    }


    renderPageHeader() {
        return (
            <div className="sale-report-page__header">
                <h1 className="sale-report-page__title">Sale Report</h1>
            </div>
        );
    }

    render() {
        if (GeneralUtils.isMobile()) {
            return (
                <div className="sale-report-page sale-report-page--full col-md-12">
                    <AvForm>
                        <div className="sale-report-page__shell">
                            {this.renderPageHeader()}
                            <div className="sale-report-page__panel">
                                {this.renderFilter()}
                                {this.renderSummaryGraphics()}
                                {this.renderArchieves()}
                            </div>
                        </div>
                    </AvForm>
                    {this.state.loading && <Loading/>}
                </div>
            );
        }

        return (
            <div className="sale-report-page sale-report-page--full col-md-12">
                <AvForm>
                    <div className="sale-report-page__shell">
                        {this.renderPageHeader()}
                        <TabView
                            className="sale-report-page__tabs"
                            activeIndex={this.state.activeIndex}
                            onTabChange={(e) => this.setState({activeIndex: e.index})}>
                            <TabPanel header="Web Sale Report">
                                <div className="sale-report-page__panel">
                                    {this.renderReport()}
                                </div>
                            </TabPanel>
                            <TabPanel header="Sale Report Archive">
                                <div className="sale-report-page__panel">
                                    {this.renderFilter()}
                                    {this.renderSummaryGraphics()}
                                    {this.renderArchieves()}
                                </div>
                            </TabPanel>
                            <TabPanel header="Merge Sale Report">
                                <div className="sale-report-page__panel">
                                    {this.renderMergeFilter()}
                                    {this.renderMerge()}
                                </div>
                            </TabPanel>
                        </TabView>
                    </div>
                </AvForm>
                {this.state.loading && <Loading/>}
            </div>
        );
    }

    renderReport() {
        return (
            <div>
                <ModalConfirm
                    header="Warning"
                    ok="Ok"
                    onOkClick={this.finaliseSaleReport}
                    onCancelClick={() => this.setState({displayConfirmDialog: false})}
                    show={this.state.displayConfirmDialog}
                    message={this.state.noticeResponse}/>

                <div className="sale-report-page__toolbar settings-page__actions settings-page__actions--inline">
                    <Button color="outline-primary" className="settings-page__btn--action" onClick={this.exportPdf}>
                        <i className="pi pi-file-pdf" aria-hidden="true"/>
                        <Translate contentKey="entity.action.pdf">Export To PDF</Translate>
                    </Button>
                    <Button color="outline-primary" className="settings-page__btn--action" onClick={this.sendEmail}>
                        <i className="pi pi-send" aria-hidden="true"/>
                        <Translate contentKey="entity.action.email">Send Email</Translate>
                    </Button>
                    <Button
                        color="outline-danger"
                        className="settings-page__btn--delete"
                        onClick={this.showConfirmDialog}>
                        <Translate contentKey="entity.action.delete">Finalise</Translate>
                    </Button>
                </div>

                <div className="sale-report-page__table-wrap sale-report-page__report-table">
                    <DataTable
                        fields={SaleReportColumn.fields}
                        ref={(elem) => this.refDataTable = elem}
                        objectName={SaleReportColumn.name}
                        rows={100}
                        reportName="Sale Report"
                        paginator={false}
                        dataURL={"reporting/zxreport/salereport"}
                        selectionMode="single"
                        loading={this.state.loading}/>
                </div>
            </div>
        );
    }

    renderFilter() {
        return (
            <div className="sale-report-page__filter">
                <div className="sale-report-page__filter-row sale-report-page__filter-row--cols-5">
                    <div className="sale-report-page__filter-field">
                        <label htmlFor="sale-report-till">Till</label>
                        <AvField
                            id="sale-report-till"
                            type="select"
                            className="form-control"
                            name="clientAgent"
                            value={this.state.clientAgent}
                            onChange={this.__handleChangeClientAgent}>
                            <option value="" key="">
                                ALL
                            </option>
                            {this.state.clientList.map(element => (
                                <option value={element.bssId} key={element.clientTillId}>
                                    {element.clientTillId}
                                </option>))}
                        </AvField>
                    </div>

                    <div className="sale-report-page__filter-field">
                        <label htmlFor="sale-report-period">Period</label>
                        <AvField
                            id="sale-report-period"
                            type="select"
                            className="form-control"
                            name="daysFilter"
                            value={this.state.daysFilter}
                            onChange={this.__handleChangeDaysFilter}>
                            {DAYS_FILTER.map(element => (
                                <option value={element.value} key={element.value}>
                                    {element.name}
                                </option>))}
                        </AvField>
                    </div>

                    <div className="sale-report-page__filter-field">
                        <label>Start Date</label>
                        <DateInput
                            name="startDate"
                            format={"DD/MM/YYYY"}
                            placeholder={"Start Date"}
                            onChange={this.__handleChangeStartDate}
                            disabled={this.state.daysFilter !== 'Custom'}
                            value={this.state.startDate}/>
                    </div>

                    <div className="sale-report-page__filter-field">
                        <label>End Date</label>
                        <DateInput
                            name="endDate"
                            format={"DD/MM/YYYY"}
                            placeholder={"End Date"}
                            onChange={this.__handleChangeEndDate}
                            disabled={this.state.daysFilter !== 'Custom'}
                            value={this.state.endDate}/>
                    </div>

                    <div className="sale-report-page__filter-actions">
                        <Button
                            color="outline-primary"
                            className="settings-page__btn--save"
                            onClick={() => this.search()}>
                            <Translate contentKey="entity.action.add">Search</Translate>
                        </Button>
                    </div>
                </div>
            </div>
        );
    }


    renderMergeFilter() {
        return (
            <div className="sale-report-page__filter">
                <div className="sale-report-page__filter-row sale-report-page__filter-row--cols-7">
                    <div className="sale-report-page__filter-field">
                        <label htmlFor="sale-report-merge-till">Till</label>
                        <AvField
                            id="sale-report-merge-till"
                            type="select"
                            className="form-control"
                            name="clientAgent"
                            value={this.state.clientAgent}
                            onChange={this.__handleChangeClientAgent}>
                            <option value="" key="">
                                ALL
                            </option>
                            {this.state.clientList.map(element => (
                                <option value={element.bssId} key={element.clientTillId}>
                                    {element.clientTillId}
                                </option>))}
                        </AvField>
                    </div>

                    <div className="sale-report-page__filter-field">
                        <label htmlFor="sale-report-merge-period">Period</label>
                        <AvField
                            id="sale-report-merge-period"
                            type="select"
                            className="form-control"
                            name="daysFilter"
                            value={this.state.daysFilter}
                            onChange={this.__handleChangeDaysFilter}>
                            {DAYS_FILTER.map(element => (
                                <option value={element.value} key={element.value}>
                                    {element.name}
                                </option>))}
                        </AvField>
                    </div>

                    <div className="sale-report-page__filter-field">
                        <label>Start Date</label>
                        <DateInput
                            name="startDate"
                            format={"DD/MM/YYYY"}
                            placeholder={"Start Date"}
                            onChange={this.__handleChangeStartDate}
                            disabled={this.state.daysFilter !== 'Custom'}
                            value={this.state.startDate}/>
                    </div>

                    <div className="sale-report-page__filter-field">
                        <label>End Date</label>
                        <DateInput
                            name="endDate"
                            format={"DD/MM/YYYY"}
                            placeholder={"End Date"}
                            onChange={this.__handleChangeEndDate}
                            disabled={this.state.daysFilter !== 'Custom'}
                            value={this.state.endDate}/>
                    </div>

                    <div className="sale-report-page__filter-field">
                        <label htmlFor="sale-report-start-no">Start Report No</label>
                        <AvField
                            id="sale-report-start-no"
                            type="number"
                            placeholder={"Start Report No"}
                            className="form-control"
                            name="reportStartNo"
                            value={this.state.reportStartNo}
                            onChange={this.__handleChangeReportStartNo}/>
                    </div>

                    <div className="sale-report-page__filter-field">
                        <label htmlFor="sale-report-end-no">End Report No</label>
                        <AvField
                            id="sale-report-end-no"
                            type="number"
                            className="form-control"
                            placeholder={"End Report No"}
                            name="reportEndNo"
                            value={this.state.reportEndNo}
                            onChange={this.__handleChangeReportEndNo}/>
                    </div>

                    <div className="sale-report-page__filter-actions">
                        <Button
                            color="outline-primary"
                            className="settings-page__btn--save"
                            onClick={() => this.mergeSaleReport()}>
                            <Translate contentKey="entity.action.add">Merge</Translate>
                        </Button>
                    </div>
                </div>
            </div>
        );
    }

    renderSummaryGraphics() {
        const tillSaleList = this.state.summary.tillSalesList || [];

        const chartTillsData = {
            labels: tillSaleList.map(item => item.name + ' ' + GeneralUtils.formatGBP(item.amount)),
            datasets: [
                {
                    label: 'Net Sales By Till',
                    backgroundColor: ['#42A5F5', '#66BB6A', '#FFA726'],
                    data: tillSaleList.map(item => parseFloat(item.amount)),
                }
            ]
        };

        const chartSalesData = {
            labels: [
                'Net ' + GeneralUtils.formatGBP(this.state.summary.netSale),
                'Gross ' + GeneralUtils.formatGBP(this.state.summary.grossSale),
                'Refund ' + GeneralUtils.formatGBP(this.state.summary.refunds)
            ],
            datasets: [
                {
                    label: 'Sale Summary Amount (£)',
                    backgroundColor: ['#42A5F5', '#66BB6A', '#FFA726'],
                    data: [
                        this.state.summary.netSale,
                        this.state.summary.grossSale,
                        this.state.summary.refunds
                    ],
                }
            ]
        };

        const chartPaymentData = {
            labels: [
                'WebPay ' + GeneralUtils.formatGBP(this.state.summary.webPay),
                'Till Card ' + GeneralUtils.formatGBP(this.state.summary.tillCard),
                'Till Cash ' + GeneralUtils.formatGBP(this.state.summary.tillCash)
            ],
            datasets: [
                {
                    label: 'Sale Summary By Payment (£)',
                    backgroundColor: ['#42A5F5', '#66BB6A', '#FFA726'],
                    data: [
                        this.state.summary.webPay,
                        this.state.summary.tillCard,
                        this.state.summary.tillCash
                    ]
                }
            ]
        };

        const chartOptions = {
            maintainAspectRatio: false,
            responsive: true,
            plugins: {
                legend: {
                    display: true,
                    labels: {
                        color: '#495057',
                        boxWidth: 10,
                        font: {size: 10},
                        padding: 6
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: '#495057',
                        font: {size: 10},
                        maxRotation: 35,
                        autoSkip: true,
                        maxTicksLimit: 4
                    },
                    grid: {
                        color: '#ebedef'
                    }
                },
                y: {
                    ticks: {
                        color: '#495057',
                        font: {size: 10}
                    },
                    grid: {
                        color: '#ebedef'
                    }
                }
            }
        };

        return (
            <div className="sale-report-page__summary">
                <h2 className="sale-report-page__summary-title">Summary</h2>
                <div className="sale-report-page__summary-grid">
                    <div className="sale-report-page__chart-card">
                        <div className="chart-container">
                            <Chart type="bar" data={chartTillsData} options={chartOptions} height={"150px"}/>
                        </div>
                        <div className="sale-report-page__chart-foot">
                            <span>Total Net Sales: {GeneralUtils.formatGBP(this.state.summary.totalSale)}</span>
                            <br/>
                            <span>Till Net Sales: {GeneralUtils.formatGBP(this.state.summary.tillTotalSale)}</span>
                        </div>
                    </div>

                    <div className="sale-report-page__chart-card">
                        <div className="chart-container">
                            <Chart type="bar" data={chartSalesData} options={chartOptions} height={"150px"}/>
                        </div>
                    </div>

                    <div className="sale-report-page__chart-card">
                        <div className="chart-container">
                            <Chart type="bar" data={chartPaymentData} options={chartOptions} height={"150px"}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }


    refreshSummary() {

        let startDate = -1;
        if (!GeneralUtils.isNullOrEmpty(this.state.startDate)) {
            startDate = this.state.startDate;
        }
        let endDate = -1;
        if (!GeneralUtils.isNullOrEmpty(this.state.endDate)) {
            endDate = this.state.endDate;
        }

        let clientAgent = "-1";
        if (!GeneralUtils.isNullOrEmpty(this.state.clientAgent)) {
            clientAgent = this.state.clientAgent;
        }

        this.zxReportService.getSummary(startDate, endDate, clientAgent).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this.setState({summary: response});
            }

        });

    }

    search() {
        if (this.state.activeIndex == 1 || GeneralUtils.isMobile()) {
            this.refDataTableArchieves.dt.filter(this.state.clientAgent, "clientAgent", "equals");
            let filterElement = this.refDataTableArchieves.state.filterElement;
            this.refDataTableArchieves.setState({filterElement: filterElement});
            this.refDataTableArchieves.onModelFilterChangeWithNameAndValue("clientAgent", this.state.clientAgent, "string");
            this.refreshSummary();
        }


    }

    mergeSaleReport() {

        let startDate = -1;
        if (!GeneralUtils.isNullOrEmpty(this.state.startDate)) {
            startDate = this.state.startDate;
        }
        let endDate = -1;
        if (!GeneralUtils.isNullOrEmpty(this.state.endDate)) {
            endDate = this.state.endDate;
        }

        let clientAgent = "-1";
        if (!GeneralUtils.isNullOrEmpty(this.state.clientAgent)) {
            clientAgent = this.state.clientAgent;
        }

        let reportStartNo = "-1";
        if (!GeneralUtils.isNullOrEmpty(this.state.reportStartNo)) {
            reportStartNo = this.state.reportStartNo;
        }

        let reportEndNo = "-1";
        if (!GeneralUtils.isNullOrEmpty(this.state.reportEndNo)) {
            reportEndNo = this.state.reportEndNo;
        }

        this.zxReportService.mergeSaleReport(startDate, endDate, clientAgent, reportStartNo, reportEndNo).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                GeneralUtils.openDialogThenRef(this, {displayMergeDialog: true}, () => this.refModelMergeSave, (ref) => {
                    ref.setData(response);
                });
            }

        });

    }

    __handleChangeClientAgent = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        this.setState({clientAgent: value}, () => {
            this.search(); // This will run after state is updated
        });
    }
    __handleChangeStartDate = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        this.setState({startDate: value}, () => {
            this.search(); // This will run after state is updated
        });
    }

    __handleChangeReportStartNo = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        this.setState({reportStartNo: value}, () => {
            this.search(); // This will run after state is updated
        });
    }

    __handleChangeReportEndNo = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        this.setState({reportEndNo: value}, () => {
            this.search(); // This will run after state is updated
        });
    }

    __handleChangeDaysFilter = (e) => {
        const selectedFilter = e.target.value;
        let startDate = null;
        let endDate = null;

        switch (selectedFilter) {
            case 'Today':
                startDate = GeneralUtils.getStartOfToday();
                endDate = GeneralUtils.getEndOfToday();
                break;
            case 'This Week':
                startDate = GeneralUtils.getMonday();
                endDate = GeneralUtils.getEndOfToday();
                break;
            case 'Last Week':
                [startDate, endDate] = GeneralUtils.getLastWeekRange();
                break;
            case 'Last 7 Days':
                [startDate, endDate] = GeneralUtils.getLast7DaysRange();
                break;
            case 'This Month':
                [startDate, endDate] = GeneralUtils.getThisMonthRange();
                break;
            case 'Last Month':
                [startDate, endDate] = GeneralUtils.getLastMonthRange();
                break;
            case 'Custom':
                [startDate, endDate] = GeneralUtils.getLast7DaysRange();
                break;
            default:
                startDate = this.state.startDate ? new Date(this.state.startDate) : null;
                endDate = this.state.endDate ? new Date(this.state.endDate) : null;
                break;
        }

        this.setState({
            daysFilter: selectedFilter,
            startDate: startDate ? startDate.getTime() : null,
            endDate: endDate ? endDate.getTime() : null
        }, () => {
            this.search(); // This will run after state is updated
        });

    };


    __handleChangeEndDate = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        this.setState({endDate: value}, () => {
            this.search(); // This will run after state is updated
        });
    }
    exportPdf = () => {
        this.refDataTable.exportPdf();
    }

    sendEmail = () => {
        this.refDataTable.sendEmail();
    }
    showConfirmDialog = () => {
        this.setState({
            displayConfirmDialog: true,
            noticeResponse: "Do you want to finalise Sale Report?"
        });
    }

    finaliseSaleReport = () => {
        this.setState({
            loading: true,
        });
        let that = this;
        this.zxReportService.finaliseSaleReport()
            .then((response) => {
                setTimeout(function () {
                    that.setState({
                        loading: false,
                    });
                    that.refDataTable.refresh();
                }, 1000);


            });

    }

    renderArchieves() {
        let startDate = -1;
        if (!GeneralUtils.isNullOrEmpty(this.state.startDate)) {
            startDate = this.state.startDate;
        }
        let endDate = -1;
        if (!GeneralUtils.isNullOrEmpty(this.state.endDate)) {
            endDate = this.state.endDate;
        }

        return (
            <div>
                <div className="sale-report-page__table-wrap sale-report-page__table-wrap--reports">
                    <DataTable
                        fields={GeneralUtils.isMobile() ? SaleReportArchieveMobileColumn.fields : SaleReportArchieveColumn.fields}
                        ref={(elem) => this.refDataTableArchieves = elem}
                        objectName={GeneralUtils.isMobile() ? SaleReportArchieveMobileColumn.name : SaleReportArchieveColumn.name}
                        onDataSelect={this.onDataSelect}
                        rows={10}
                        reportName="Sale Report"
                        paginator={true}
                        dataURL={"reporting/zxreport/salereport/archieve/" + startDate + "/" + endDate}
                        selectionMode="single"
                        loading={this.state.loading}/>
                </div>

                <Dialog visible={this.state.displayDialog}
                    header={"Sale Report Details"}
                    onHide={() => this.setState({displayDialog: false})}
                    style={GeneralUtils.getDialogStyleForReportDialogDetail()}>

                <SaleReportDetail closeDisplayDialog={this.closeDisplayDialog} ref={(elem) => this.refModelSave = elem}
                />
            </Dialog>


            </div>
        );
    }

    renderMerge() {

        return (
            <div>

            <Dialog visible={this.state.displayDialog}
                    header={"Sale Report Details"}
                    onHide={() => this.setState({displayDialog: false})}
                    style={GeneralUtils.getDialogStyleForReportDialogDetail()}>

                <SaleReportDetail closeDisplayDialog={this.closeDisplayDialog} ref={(elem) => this.refModelSave = elem}
                />
            </Dialog>

            <Dialog visible={this.state.displayMergeDialog}
                    header={"Sale Report Details"}
                    onHide={() => this.setState({displayMergeDialog: false})}
                    style={GeneralUtils.getDialogStyleForReportDialogDetail()}>

                <SaleReportMergeDetail closeDisplayDialog={this.closeDisplayDialog}
                                       ref={(elem) => this.refModelMergeSave = elem}
                />
            </Dialog>


            </div>
        );
    }

    onDataSelect = (data) => {
        GeneralUtils.openDialogThenRef(this, {displayDialog: true}, () => this.refModelSave, (ref) => {
            ref.setData(Object.assign({}, data));
        });
    }

    closeDisplayDialog = () => {
        this.setState({displayDialog: false, displayMergeDialog: false});
    }


}

